import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { PaginationParams } from './../../../models/shared/paginationParams.model';
import { CommunicationService } from './../../../shared/services/communication.service';
import { EntityService } from './../../../shared/services/entity.service';
import { File } from '../../../models/files/files.model';

import * as appConfig from '../../../app.config';
import { ApiService } from './../../../shared/services/api.service';
import { DataUtils } from './../../../shared/utils/data-utils';

@Component({
  selector: 'swb-entity-browse',
  templateUrl: './entity-browse.component.html',
  styleUrls: ['./entity-browse.component.scss']
})
export class EntityBrowseComponent implements OnInit, OnDestroy {
  private _subscription: Subscription;
  public q = '';
  public downloadUrl = appConfig.apiUrl + 'entities/download/';
  public chosen: any[] = [];
  public isSingle = false;
  public imgOnly = false;
  public apiUrl = '';
  public singleFromUrl = false;

  @Input()
  set query(query: string) {
    if (query) {
      this.q = query;
      this._getPaginationParams(query);
      this.p = 1;
      this._getEntities(query, '/filter/');
    } else {
      this.q = '';
      this._getPaginationParams('');
      this._getEntities(this.q, '');
    }
  }

  public entities: any[];

  public pagination: PaginationParams = {
    pageSize: 0,
    total: 0
  };

  public p = 1;

  constructor(
    private _apiService: ApiService,
    private _communicationService: CommunicationService,
    private _entitiesService: EntityService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
    this._activatedRoute.params.subscribe(params => {
      const apiUrl = params['url'];
      this.apiUrl = apiUrl;
      const isMultiple = params['single'] !== 'true';
      this.isSingle = !isMultiple;
      this.singleFromUrl = true;
    });
  }

  public getTitle(titleObject: any): string {
    return DataUtils.getTitle(titleObject);
  }

  ngOnInit() {
    if (this._route.snapshot.data.imgOnly) {
      this.imgOnly = this._route.snapshot.data.imgOnly;
    }

    if (this._route.snapshot.data.isSingle && !this.singleFromUrl) {
      this.isSingle = this._route.snapshot.data.isSingle;
    }

    window.scrollTo(0, 0);

    this._subscription = this._communicationService.modalExecuted$.subscribe(
      () => {
        this._getPaginationParams('');
        this._getEntities(this.q, '');
      }
    );

    this._getPaginationParams('');
    this._getEntities(this.q, '');
  }

  public pageChanged(p): void {
    this.p = p;
    let uri = '';
    if (this.q.length > 0) {
      uri = '/filter/';
    }
    this._getEntities(this.q, uri);
  }

  public getBoxStyle(file: File): any {
    if (!file) {
      return;
    }

    if (file.is_image) {
      if (file.is_resizable) {
        return {
          'background-image':
            'url(' +
            appConfig.apiUrl +
            appConfig.mediaFolder +
            '460x460_' +
            file.file_fullname +
            ')'
        };
      }
      return {
        'background-image':
          'url(' +
          appConfig.apiUrl +
          appConfig.mediaFolder +
          file.file_fullname +
          ')'
      };
    }

    return {};
  }

  // TODO: imgOnly filter!
  public reloadList($event): void {
    let uri = '';
    if (this.q.length > 0) {
      uri = '/filter/';
    }
    this._getEntities(this.q, uri);
    this._getPaginationParams(this.q);
  }

  private _getEntities(query: string, uri: string) {
    this._apiService
      .get(this.apiUrl + uri + query + '?page=' + this.p + '?imgOnly=' + this.imgOnly)
      .subscribe(
        (response: any) => {
          this.entities = { ...response }.data;
        },
        error => console.error(error)
      );
  }

  public chooseEntity(entity: any) {
    if (this.isSingle) {
      if (this.chosen.includes(entity)) {
        this.chosen = [];
      } else {
        this.chosen = [entity];
      }
    } else {
      if (this.chosen.includes(entity)) {
        const index = this.chosen.indexOf(entity);
        this.chosen.splice(index, 1);
      } else {
        this.chosen.push(entity);
      }
    }
  }

  public isString(val: any) {
    return typeof val === 'string';
  }

  public submitEntities() {
    this._entitiesService.setChosenEntities(this.chosen, this.apiUrl);
    this._router.navigate([{ outlets: { browse: null } }], {
      relativeTo: this._route.parent
    });
  }

  public close() {
    this._router.navigate([{ outlets: { browse: null } }], {
      relativeTo: this._route.parent
    });
  }

  public filter(query: string): void {
    this.query = query;
  }

  private _getPaginationParams(query: string) {
    this._apiService
      .get(this.apiUrl + '/pagination/' + query + '?imgOnly=' + this.imgOnly)
      .subscribe(
        (response: any) => {
          this.pagination = { ...response?.data };
        },
        error => console.error(error)
      );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._router.navigate([{ outlets: { browse: null } }], {
      relativeTo: this._route.parent
    });
  }
}
